import { Component } from '@angular/core';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';
import { FormlyProps, MenuService } from '../../../services';

@Component({
  selector: 'app-formly-select',
  templateUrl: './formly-select.component.html',
  styleUrl: './formly-select.component.scss',
})
export class FormlySelectComponent extends FormlyFieldBaseComponent {
  defaultOptions = {
    props: { options: [] },
  };

  constructor(public menuService: MenuService) {
    super();
  }

  get showCreate(): boolean {
    return this.props.create && (!this.props.showCreate || this.props.showCreate(this.model));
  }

  get showDelete(): boolean {
    return this.props.delete && (!this.props.showDelete || this.props.showDelete(this.model));
  }

  getValue(options: FormlyProps[]) {
    const value = this.model[this.key as string];
    return value ? options.find((option: FormlyProps) => option.value === value)?.label : '';
  }

  onCreate(event: any) {
    if (this.props.create) {
      this.props.create(event);
    }
  }

  onDelete(event: any) {
    if (this.props.delete) {
      this.props.delete(event);
    }
  }
}
